// extracted by mini-css-extract-plugin
export default {"favoriteButton":"DocumentVersionFavoriteButton_favoriteButton__Mo3Gk","btnText":"DocumentVersionFavoriteButton_btnText__Yxc+J"};